import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { TableHeader } from './table-header';

export const TableHeaderModule: string = ng
    .module('table-header', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('tableHeader', TableHeader)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/table-component/table-header/table-header.module.ts